import type { ToolsDiff } from '@/features/Integrations/types/integration';

export interface ToolsDiffCount {
  added: number;
  removed: number;
  changed: number;
  total: number;
}

/** Os arrays podem vir ausentes de um backend que só devolve o que mudou. */
export function countToolsDiff(diff: Partial<ToolsDiff> | null | undefined): ToolsDiffCount {
  const added = diff?.added?.length ?? 0;
  const removed = diff?.removed?.length ?? 0;
  const changed = diff?.changed?.length ?? 0;
  return { added, removed, changed, total: added + removed + changed };
}

export function isToolsDiffEmpty(diff: Partial<ToolsDiff> | null | undefined): boolean {
  return countToolsDiff(diff).total === 0;
}

/**
 * O que vem marcado ao abrir a comparação: o que o template acrescentou ou mudou. As tools
 * que só existem nesta instalação ficam desmarcadas — muitas foram criadas pela própria
 * organização, e aplicar o template as apagaria.
 */
export function defaultDiffSelection(diff: Partial<ToolsDiff> | null | undefined): string[] {
  return diffToolNames({ added: diff?.added, changed: diff?.changed });
}

/**
 * Nomes de tool que o diff toca, sem repetir — é o que o `template-diff/apply` recebe.
 * Numa tool alterada vale o `name` do diff, caindo no de `after` (o do template) e no de `before`.
 */
export function diffToolNames(diff: Partial<ToolsDiff> | null | undefined): string[] {
  const names = [
    ...(diff?.added ?? []).map((tool) => tool.name),
    ...(diff?.removed ?? []).map((tool) => tool.name),
    ...(diff?.changed ?? []).map((change) => change.name ?? change.after?.name ?? change.before?.name),
  ].filter((name): name is string => typeof name === 'string' && name.length > 0);
  return Array.from(new Set(names));
}

/** Skills que usam alguma tool que vai sumir ou mudar — o aviso antes de aceitar o refresh (AB#87477). */
export function affectedSkillCount(
  preview: { affected_skills?: { name: string; tools: string[] }[] } | null | undefined,
): number {
  return (preview?.affected_skills ?? []).filter((skill) => skill.tools.length > 0).length;
}
